const paymentOptions = {
	Egypt: ['Less than EGY 1.5m', 'EGY 1.5m - 8m', 'EGY 8m - 16m', 'EGY 16m - 160m', 'More than EGY 160m'],
	Ghana: ['Less than GHS 600k', 'GHS 600k - 3m', 'GHS 3m - 6m', 'GHS 6m - 60m', 'More than GHS 60m'],
	Kenya: ['Less than KES 500k', 'KES 500k - 5m', 'KES 5m - 50m', 'KES 50m - 120m', 'More than KES 120m'],
	Nigeria: ['Less than NGN 50m', 'NGN 50m - 200m', 'NGN 200m - 400m', 'NGN 400m - NGN 4bn', 'More than NGN 4bn'],
	'South Africa': ['Less than ZAR 1.5m', 'ZAR 1.5m - 8m', 'ZAR 8m - 16m', 'ZAR 16m - 160m', 'More than ZAR 160m'],
	default: ['Less than USD 100k', 'USD 100k to 500k', 'USD 500k to 1m', 'USD 1m to 10m', 'More than USD 10m'],
};

export default paymentOptions;
